import { Modal } from '@didi/driver-biz-ui'
import { omega } from '@didi/driver-biz-sdk'

export function showPersonInfoModal(companyName: string, url?: string): Promise<boolean> {
  let content = `您在滴滴平台的预留信息：姓名、身份证件号码、手机号码，将提供给【${companyName}】用于快速办理医疗及意外保障计划，未经您的许可，前述信息将不作他用。`
  if (url) {
    content = content + `点击下方授权按钮代表您已阅读并同意<a style="color: #ff5303" href="${url}">《个人信息授权书》</a>`
  }
  // empty
  const promise: Promise<boolean> = new Promise((resolve, reject) => {
    Modal.$create({
      title: '个人信息授权申请',
      content,
      direction: 'horizontal',
      confirmBtn: '同意授权',
      cancelBtn: '暂不授权',
      onConfirm: () => {
        omega.trackEvent('am_c_insure_mediendow_auth_ck', { insure_type: 2 })
        resolve(true)
      },
      onClose: () => {
        omega.trackEvent('am_c_insure_mediendow_noauth_ck', { insure_type: 2 })
        reject(new Error('fail close'))
      },
      onCancel: () => {
        omega.trackEvent('am_c_insure_mediendow_noauth_ck', { insure_type: 2 })
        reject(new Error('fail cancel'))
      }
      // eslint-disable-next-line
      // @ts-ignore
    }, (h) => {
      return h('img', {
        style: {
          width: '140px',
          'margin-bottom': '10px'
        },
        attrs: {
          src: 'https://dpubstatic.udache.com/static/dpubimg/B5wrDG1NXY4B63qOse4Gv.png'
        },
        slot: 'icon'
      }, 1)
    }).show()
  })
  return promise
}
